/*
 * @Description: user Mutations
 */
import { MutationTree } from 'vuex'
import { DataAnalysisState } from './state'
import { AnalysisMutationTypes } from './mutation-types'

export type Mutations<S = DataAnalysisState> = {
  [AnalysisMutationTypes.SET_SCREENFULL](state: S, screenfull: boolean): void
  [AnalysisMutationTypes.SET_SCREENTHEME](state: S, screenTheme: string): void
}

export const mutations: MutationTree<DataAnalysisState> & Mutations = {
  [AnalysisMutationTypes.SET_SCREENFULL](state: DataAnalysisState, screenfull: boolean) {
    state.screenfull = screenfull
  },
  [AnalysisMutationTypes.SET_SCREENTHEME](state: DataAnalysisState, screenTheme: string) {
    state.screenTheme = screenTheme
  },
}
